import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, params, classes) => ({
    container: {
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column-reverse',
        placeContent: 'center',
    },
    heading: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.between('md', 'xl')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm), [theme.breakpoints.up('lg')]: Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm) }),
    contentInner: {
        '&  :last-child': {
            marginBottom: '0px',
        },
    },
    message: {
        '&, & p,': Object.assign(Object.assign(Object.assign({ paddingTop: '1px', paddingBottom: '3px' }, theme.typography.small_regular), theme.typographySpacing.none), { marginBottom: spacing.large, [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.medium_regular), [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.large_regular) }),
    },
    linkContainer: {
        '&': {
            display: 'inline-flex',
            flexDirection: 'column',
            marginBottom: spacing.large,
            gap: 0,
            [theme.breakpoints.up('md')]: {
                marginBottom: 0,
            },
            [theme.breakpoints.up('xl')]: {
                display: !!params.links && (params === null || params === void 0 ? void 0 : params.links) > 1 ? 'flex ' : 'inline-flex ',
                flexDirection: 'row ',
                [`& .${classes.link}`]: {
                    flex: '50%',
                    width: '100%',
                    margin: 0,
                    padding: `0 ${spacing.xs}`,
                    '& button': { width: '100%' },
                },
            },
        },
        '& :last-child': {
            marginBottom: 0,
        },
    },
    link: {
        [theme.breakpoints.up('xl')]: {
            flex: '50%',
            width: '100%',
            margin: 0,
            padding: `0 ${spacing.xs}`,
            '& button': { width: '100%' },
        },
    },
    content: {
        position: 'absolute',
        [theme.breakpoints.up('sm')]: {
            position: 'relative',
        },
    },
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    positionCenter: {
        [theme.breakpoints.up('sm')]: {
            [`& .${classes.content}`]: {
                width: '100%',
            },
        },
    },
    bannerImage: {
        '& img': {
            objectFit: 'cover',
        },
        paddingTop: '100%',
        [theme.breakpoints.up('xs')]: {
            paddingTop: '0%',
        },
    },
}));
export default useStyles;
